module.exports = __webpack_public_path__ + "static/Fanhome_Popup_Newsletter_DESKTOP-293e25485e734f686a9e230e4852d4cc.png";